export default {
    name: 'course-sidebar-recommendations'
}
